// Dashboard
import Dashboard from './views/dashboard.js/Dashboard'

// Game
import AddGame from './views/games/AddGame'
import EditGame from './views/games/EditGame'
import GameList from './views/games/GameList'
import GameDetails from './views/games/GameDetails'

// Game Voucher
import AddGameVoucher from './views/gameVouchers/AddGameVoucher'
import EditGameVoucher from './views/gameVouchers/EditGameVoucher'
import GameVoucherList from './views/gameVouchers/GameVoucherList'
import GameVoucherDetails from './views/gameVouchers/GameVoucherDetails'

// Client Voucher
import AddClientVoucher from './views/clientVouchers/AddClientVoucher'
import EditClientVoucher from './views/clientVouchers/EditClientVoucher'
import ClientVoucherList from './views/clientVouchers/ClientVoucherList'
import ClientVoucherDetails from './views/clientVouchers/ClientVoucherDetails'

// Claim History
import ClaimHistoryList from './views/claimHistories/ClaimHistoryList'
import ClaimHistoryDetails from './views/claimHistories/ClaimHistoryDetails'

const routes = [
  { path: '/', exact: true, name: 'Home', element: Dashboard },
  { path: '/game/add', name: 'Add Game', element: AddGame },
  { path: '/game/edit/:id', name: 'Edit Game', element: EditGame },
  { path: '/game/list', name: 'Game List', element: GameList },
  { path: '/game/details/:id', name: 'Game Details', element: GameDetails },
  { path: '/game-voucher/add', name: 'Add Game Voucher', element: AddGameVoucher },
  { path: '/game-voucher/edit/:id', name: 'Edit Game Voucher', element: EditGameVoucher },
  { path: '/game-voucher/list', name: 'Game Voucher List', element: GameVoucherList },
  { path: '/game-voucher/details/:id', name: 'Game Voucher Detail', element: GameVoucherDetails },
  { path: '/client-voucher/add', name: 'Add Client Voucher', element: AddClientVoucher },
  { path: '/client-voucher/edit/:id', name: 'Edit Client Voucher', element: EditClientVoucher },
  { path: '/client-voucher/list', name: 'Client Voucher List', element: ClientVoucherList },
  { path: '/client-voucher/details/:id', name: 'Client Voucher Detail', element: ClientVoucherDetails },
  { path: '/claim-history/list/:status', name: 'Claim History List', element: ClaimHistoryList },
  { path: '/claim-history/details/:id', name: 'Claim History Detail', element: ClaimHistoryDetails },
]

export default routes
